module.exports = __webpack_public_path__ + "img/node.5f4b1476.svg";